import { Avatar } from "antd";
import React from "react";

const UserInfo = (props) => {
  const { utilisateur, collapsed } = props;

  const classNames =
    utilisateur.societe_id === 19
      ? "ast-user-info-inner ast-user-info ast-user-map"
      : "ast-user-info-inner ast-user-info";

  return (
    <div className={classNames}>
      <div className="ast-user-info-inner">
        <Avatar className="ast-user-info-avatar" size={40}>
          {utilisateur.utilisateur_nom.charAt()}
        </Avatar>
        {!collapsed && (
          <span className="ast-user-info-content">
            <span className="ast-user-name-info">
              <h4 className="ast-user-name text-truncate">{utilisateur.utilisateur_nom}</h4>
            </span>
            <span className="ast-user-societe text-truncate">
              {utilisateur.utilisateur_societe.societe_raison_sociale}
            </span>
          </span>
        )}
      </div>
    </div>
  );
};

export default UserInfo;
